// extracted by css-extract-rspack-plugin
export default {"container":"crxHE_hXI74R4vsM"};